import { Navigate, Route, Routes } from "react-router-dom";
import CreateReport from "../pages/backoffice/CreateReport";
import Home from "../pages/backoffice/Home";
import { useAuth } from "../context/AuthContext";
import Report from "../pages/backoffice/Report";
import Settings from "../pages/backoffice/Settings";
import { ROLE_SETTINGS_BACKKOFFICE_ADMIN } from "../constants";

export function BackofficeAccess() {
	const { isAuthenticated, userData } = useAuth();

	if (!isAuthenticated) {
		return <Navigate to="/auth/login" />;
	}

	const hasSettingsAccess = userData?.user.userRoles?.includes(ROLE_SETTINGS_BACKKOFFICE_ADMIN);
 
	return (
		<div className="app-content flex-grow-1">
			<Routes>
				<Route index path="/" element={<Home />} />
				<Route path="/create-report" element={<CreateReport />} />
				<Route path="/report/:findReportID" element={<Report />} />
				{hasSettingsAccess && <Route path="/settings/*" element={<Settings />} />}
			</Routes>
		</div>
	);
}
